/** Segmented control in stile iOS con "knob" animato. */
export interface SegmentOption<T extends string> {
  value: T;
  label: string;
}

export function Segmented<T extends string>({
  value,
  options,
  onChange,
  ariaLabel,
}: {
  value: T | null;
  options: SegmentOption<T>[];
  onChange: (v: T) => void;
  ariaLabel: string;
}) {
  const idx = options.findIndex((o) => o.value === value);
  const n = options.length;
  return (
    <div className="segmented" role="group" aria-label={ariaLabel}>
      <div
        className="segmented__knob"
        style={{
          width: `calc((100% - 4px) / ${n})`,
          transform: `translateX(${Math.max(0, idx) * 100}%)`,
          opacity: idx < 0 ? 0 : 1,
        }}
      />
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          className={`segmented__btn${o.value === value ? ' segmented__btn--active' : ''}`}
          aria-pressed={o.value === value}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
